/**
* Multi Image Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Multi Image Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'multi-image-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.multi-image-left-right' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--multi-image-left-right' )[0], {
          type: 'slide',
          pagination: false,
          perPage: 1,
          perMove: 1,
          drag: false,
          autoHeight: true,
          keyboard: true,
        } );

        splide.mount();

        let currentSlide = 0;
        let status = '';
        splide.on( 'move', function( Slide ) {
          if ( Slide == currentSlide ) return;

          if ( Slide > currentSlide ) {
            status = 'proceed';
          } else {
            status = 'reverse';
          }

          currentSlide = Slide;

          $( component ).find( '.image-wrapper' ).each( function( imageKey, image ) {
            if ( status == 'proceed' ) {
              $( image ).attr( 'data-image', ( parseInt( $( image ).attr( 'data-image' ) ) - 1 ) );
              if ( ( parseInt( $( image ).attr( 'data-image' ) ) ) < 0 ) {
                $( image ).addClass( 'is-past' );
              }
            } else if ( status == 'reverse' ) {
              $( image ).attr( 'data-image', ( parseInt( $( image ).attr( 'data-image' ) ) + 1 ) );

              if ( ( parseInt( $( image ).attr( 'data-image' ) ) ) >= 0 ) {
                $( image ).removeClass( 'is-past' );
              }
            }
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'multi-image-left-right', COMPONENT );
} )( app );
